import BaseAPIService from './base.service';

export default class MuxAPIService extends BaseAPIService {
  apiBase: string | undefined;
  rootEndpoint: string;

  constructor(apiBase?: string) {
    super();
    this.rootEndpoint = '/api/mux';
    if (apiBase) this.apiBase = apiBase;
  }

  async createUpload() {
    try {
      const endpoint = `${this.rootEndpoint}/upload`;
      const res = await super.get({ apiBase: this.apiBase, endpoint });
      return res.json();
    } catch (err: any) {
      console.log('MuxAPIService::createUpload() ', err);
      throw new Error(err.message);
    }
  }

  async getAssetsById(id: string) {
    try {
      const endpoint = `${this.rootEndpoint}/assets/${id}`;
      const res = await super.get({ apiBase: this.apiBase, endpoint });
      return res.json();
    } catch (err: any) {
      console.log('MuxAPIService::getAssetsById() ', err);
      throw new Error(err.message);
    }
  }

  async getSourceByAssetId(id: string) {
    try {
      const endpoint = `${this.rootEndpoint}/source/${id}`;
      const res = await super.get({ apiBase: this.apiBase, endpoint });
      return res.json();
    } catch (err: any) {
      console.log('MuxAPIService::getSourceByAssetId() ', err);
      throw new Error(err.message);
    }
  }

  async getAssetsByUploadId(id: string) {
    try {
      const endpoint = `${this.rootEndpoint}/upload/${id}`;
      const res = await super.get({ apiBase: this.apiBase, endpoint });
      return res.json();
    } catch (err: any) {
      console.log('MuxAPIService::getSourceByAssetId() ', err);
      throw new Error(err.message);
    }
  }
}
